<template>
    <CustomInput
        name="pesel"
        :value="pesel"
        label="PESEL number"
        :errorMessage="errors.pesel"
        @input="$emit('update:pesel', $event)"
        @valueChanged="$listeners.valueChanged"
        @blur="$listeners.blur"
    />
</template>

<script>

    export default {
        props: {
            pesel: {
                type: String,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/authentication/components/register/Id.vue